import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import mockUser from '@/assets/mock-items/mock-user.jpg';
import FontIcon from '@/components/@base/font-icon';
import { motion } from 'framer-motion';
import React from 'react';
import { useLiveStreaming } from '@/hooks/useLiveStreaming';
import useCommonModalStore from '@/store/common-modal-store';
import Button from '@/components/@base/button';
import { SIZE_ENUM } from '@/components/@base/@types';
import { usePostCancelCall } from '@/services/hooks';

const Support = ({
  cancelCall,
  status,
  supportData,
}: {
  cancelCall: () => void;
  status: string;
  supportData: any;
}) => {
  const bars = Array.from({ length: 14 });
  const { isConnected, stop, start } = useLiveStreaming();

  const { mutate: mutateCancelCall } = usePostCancelCall();
  const declineCall = () => {
    cancelCall();
    stop();
    mutateCancelCall(undefined, {
      onSuccess: () => {}
    });
  };
  const { setShow } = useCommonModalStore();
  const startScreenRecording = () => {
    setShow(false);
    start();
  };
  const showConfirmModal = () => {
    setShow(true, {
      center: true,
      dialogPanelClassName: 'px-0 pb-0 w-[85%] md:w-[380px]',
      Body: () => (
        <Container center className='flex-col p-4 pt-2'>
          <Text semiBold className='mb-2 text-xl text-grayLight-1000 dark:text-grayLight-0'>
            اشتراک‌گذاری صفحه با پشتیبانی
          </Text>
          <Text
            medium
            size={SIZE_ENUM.SM}
            className='mb-8 text-center text-grayLight-850 dark:text-[#CCCCD1]'
          >
            برای راهنمایی بهتر، می‌توانید صفحه پرداخت خود را با پشتیبانی اوزون به اشتراک
            بگذارید.
          </Text>
          <Button
            className='text-md w-full whitespace-nowrap rounded-full bg-blue px-8 text-white hover:bg-blue dark:bg-blue dark:text-white dark:hover:bg-blue'
            style={{ height: '52px' }}
            size={SIZE_ENUM.XL}
            onClick={startScreenRecording}
            id='upg-choose-asset-selection'
          >
            اشتراک‌گذاری صفحه
          </Button>
          <Button
            className='text-md cursor-pointe mt-3 w-full whitespace-nowrap rounded-full bg-grayLight-100 px-8 text-grayLight-1000 hover:bg-grayLight-1000/10 dark:bg-grayDark-750 dark:text-white'
            style={{ height: '52px' }}
            size={SIZE_ENUM.XL}
            id='upg-continue-perchese-whithout-asset-selection'
            onClick={() => setShow(false)}
          >
            فعلا نه
          </Button>
        </Container>
      ),
    });
  };

  return (
    <motion.div
      initial={{
        opacity: 0,
        y: -40,
        scale: 0.9,
      }}
      animate={{
        opacity: 1,
        y: 0,
        scale: 1,
      }}
      exit={{
        opacity: 0,
        y: -30,
        scale: 0.95,
      }}
      transition={{
        duration: 0.35,
        ease: 'easeOut',
      }}
      className='fixed top-20 z-[9] mx-auto w-[calc(100%-32px)] max-w-[358px]'
    >
      <Container
        center
        className='mx-auto flex h-14 w-[calc(100%-32px)] max-w-[348px] justify-between gap-2 rounded-2xl border border-gray-100 bg-white px-2 shadow-[0_0_16px_0_#00000040] dark:border-grayLight-900 dark:bg-grayLight-990'
      >
        <Container className='flex gap-2'>
          <img
            src={supportData.serverExtensionProfileURL}
            alt='support'
            className='rounded-full'
            width={40}
            height={40}
          />

          <Container className='flex flex-col items-start gap-1'>
            <Text className='text-xs font-medium text-black dark:text-white'>
              {supportData.serverExtensionTitle}
            </Text>

            <Text className='whitespace-nowrap text-xs text-gray-400 dark:text-grayLight-650'>
              {status}
            </Text>
          </Container>
        </Container>

        {/* Voice Bars */}
        <div className='flex h-12 items-center gap-[4px]'>
          {bars.map((_, i) => (
            <motion.div
              key={i}
              animate={{
                height: [
                  `${8 + Math.random() * 10}px`,
                  `${20 + Math.random() * 30}px`,
                  `${8 + Math.random() * 10}px`,
                ],
              }}
              transition={{
                duration: 0.8,
                repeat: Infinity,
                delay: i * 0.04,
                ease: 'easeInOut',
              }}
              className='w-[3px] rounded-full bg-primary-600 dark:bg-primary-300'
            />
          ))}
        </div>

        {isConnected ? (
          <FontIcon
            icon='icon-cross'
            className='text-md flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-black text-white dark:bg-white dark:text-black'
            onClick={() => stop()}
          />
        ) : (
          <FontIcon
            icon='icon-share'
            className='text-md flex h-8 w-8 cursor-pointer items-center justify-center rounded-full pr-[2px] bg-blue text-white '
            onClick={showConfirmModal}
          />
        )}

        <FontIcon
          icon='icon-call-righ'
          className='text-md flex h-8 w-8 rotate-[135deg] cursor-pointer items-center justify-center rounded-full bg-red text-white dark:bg-red-300'
          onClick={declineCall}
        />
      </Container>
    </motion.div>
  );
};

export default Support;
